export default {
      id: "reddit-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#reddit-usage",
      toString: function () {
        return this.url;
      }
    }